export enum UserManagementMode {
  Director = 'director-mode',
  AuthPerson = 'auth-person-mode',
}
